package org.example.loadingkdz.models

import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

enum class Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#E53E15", rgb = rgb(r = 229, g = 62, b = 21)),
    Secondary(hex = "aa1400", rgb = rgb(r = 170, g = 20, b = 0)),
    Gray(hex = "#CFCFCF", rgb = rgb(r = 207, g = 207, b = 207)),
    LightGray(hex = "#EDEDED", rgb = rgb(r = 237, g = 237, b = 237)),
    LighterGray(hex = "#CCCCCC", rgb = rgba(r = 204, g = 204, b = 204, 0.8)),
    Background(hex = "f3ffea", rgb = rgb(r = 243, g = 255, b = 234)),
    DarkBlue(hex = "0e1e47", rgb = rgb(r = 15, g = 30, b = 70))
}